import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Button} from 'aui-react';

import {routes} from '../../../constants/';

import styles from '../NewEventsTable.less';

export class AcknowledgeButton extends PureComponent {
    static propTypes = {
        canDismissEvents: PropTypes.bool,
    };

    static defaultProps = {
        canDismissEvents: false,
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    dismissEvents() {
        window.location = routes.dismissEvents;
    }

    render() {
        if (!this.props.canDismissEvents || window.location.hash === '#no-admin') {
            return null;
        }

        return (
            <div className={classnames('aui-item', styles.acknowledgeButton, 'ack-button-wrapper')} data-wd-id="acknowledge-warnings">
                <Button onClick={this.dismissEvents}>
                    {this.context.i18n('johnson.check.acknowledge.warnings.cta')}
                </Button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    canDismissEvents: state.events.canDismissEvents,
});

export default connect(mapStateToProps)(AcknowledgeButton);



// WEBPACK FOOTER //
// ./src/components/NewEventsTable/Rows/AcknowledgeButton.js